<template>
  <a-modal
    wrap-class-name="password-modal"
    :visible="visible"
    :mask-closable="false"
    :confirm-loading="loading"
    :ok-button-props="{ disabled: submitDisabled }"
    @ok="handleSubmit"
    @cancel="$emit('update:visible', false)"
  >
    <template #title>
      <lock-filled class="ic-lock" />
      <span>{{ $t('common_text_034') }}</span>
    </template>
    <div v-if="isNeedPassword" class="password-input">
      <a-input-password v-model:value="password" autocomplete="new-password" focus :placeholder="$t('common_text_035')" />
    </div>
    <div v-if="isNeed2Fa" class="otp-block">
      <div class="otp-label">{{ $t('common_text_2fa_code') || '2FA Code' }}</div>
      <otp-code v-model="otpCode" :autofocus="false" @complete="onOtpComplete" />
    </div>
    <div v-if="errorTip" class="error-tip">{{ errorTip }}</div>
  </a-modal>
</template>
<script>
import { reactive, toRefs, computed } from 'vue'
import i18n from '@/locale'
import md5 from 'js-md5'
import { _pay } from '@/api'
import OtpCode from '@/components/otp-code.vue'
export default {
  name: 'PasswordModal',
  components: { OtpCode },
  props: {
    visible: {
      type: Boolean,
      default: () => { return false }
    },
    isNeed2Fa: { // 是否需要二次验证(OTP)
      type: Boolean,
      default: false
    },
    isNeedPassword: {
      type: Boolean,
      default: true
    }
  },
  setup(props, ctx) {
    const state = reactive({
      loading: false,
      password: '',
      otpCode: '',
      errorTip: ''
    })

    const submitDisabled = computed(() => {
      if (props.isNeedPassword && !state.password) return true
      if (props.isNeed2Fa) return state.otpCode.length !== 6
      return false
    })

    const onOtpComplete = () => {
      // placeholder for future side-effects
    }

    const handleSubmit = async () => {
      if (props.isNeedPassword && !state.password) {
        state.errorTip = i18n.global.t('common_text_036')
        return
      }
      if (props.isNeed2Fa && state.otpCode.length !== 6) {
        state.errorTip = i18n.global.t('common_text_2fa_code_tip') || '请输入6位验证码'
        return
      }
      state.errorTip = ''
      let token = ''
      state.loading = true
      const { email } = JSON.parse(localStorage.getItem('userInfo'))
      const passwdMap = [{ key: 0, value: md5(email + state.password) }, { key: 'otp', value: state.otpCode }]
      const res = await _pay.checkPayPassword(passwdMap)
      if (res.data.succ) {
        token = res.data.data
      } else {
        state.errorTip = res.data.resMsg
        state.loading = false
        return
      }
      const otp = state.otpCode
      if (props.isNeedPassword) state.password = ''
      state.otpCode = ''
      state.errorTip = ''
      ctx.emit('update:visible', false)
      // 兼容：第一个参数为 token(可能为空字符串)，第二参数为 otp
      ctx.emit('pass', token, otp)
      state.loading = false
    }

    return {
      handleSubmit,
      submitDisabled,
      onOtpComplete,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
.password-modal {
  .ic-lock {
    color: @main-color;
    margin-right: 5px;
  }
  .error-tip {
    margin-top: 8px;
    color: @error-color;
  }
  .otp-block {
    margin-top: 16px;
    .otp-label {
      margin-bottom: 8px;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
